import "../AppHeader.scss";

import React, { useState } from "react";
import { AiFillFolder, AiFillFolderOpen } from "react-icons/ai";

const icons = {
  dashboard: "BiHomeAlt",
  viewCases: "BsBriefcase",
  searchCases: "BiSearchAlt",
  duplicateCases: "FaSearchengin",
  submissionRules: "SiMinutemailer",
  qualifiedCases: "BiCollection",
  queueManagement: "BiAddToQueue",
  triageRules: "RiRemoteControl2Line",
  caseAssignment: "MdAssignmentTurnedIn",
  roleManagement: "ImStack",
  userManagement: "FiUser",
  productConfiguration: "ImStack",
  studyConfiguration: "ImStack",
  reports: "ImStack",
  documentReview: "ImStack",
  auditTrail: "FaClipboardList",
};

function GroupedNav({ active, checkingDataToShowPrompt, RenderIcon, itemKey, items = [] }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <ul className="nav-list-item" data-testid="openFolder" onClick={() => setExpanded(!expanded)}>
        {expanded ? <AiFillFolderOpen /> : <AiFillFolder />}
        <p>{itemKey}</p>
      </ul>
      <div className={`${expanded ? "open-submenu" : "close-submenu"}`}>
        {items?.map((innerItem, index) => (
          <li
            key={innerItem?.moduleDisplayName}
            className={`nav-list-item ${active === innerItem?.moduleDisplayName ? "nav-list-item-active" : ""}`}
          >
            <button
              type="button"
              className="submenu-list"
              onClick={(e) =>
                checkingDataToShowPrompt(e, innerItem?.moduleDisplayName, `/${innerItem?.moduleName?.toLowerCase()}`)
              }
            >
              <div className="individual-items">
                <RenderIcon icon={icons[innerItem?.moduleName]} />
                <p>{innerItem?.moduleDisplayName}</p>
              </div>
            </button>
          </li>
        ))}
      </div>
    </div>
  );
}

export default GroupedNav;
